/* Lupine Lane Heirloom theme. No dependencies. */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {
    cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart', root: '/'
  };
  var root = routes.root.replace(/\/$/, '');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Cart drawer ---------------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.cart-drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function refreshDrawer() {
    return fetch(root + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!drawer || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('[data-cart-drawer-content]', doc);
        var current = $('[data-cart-drawer-content]', drawer);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(function () {
        return fetch(root + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart.item_count); });
  }

  // Pairings: "+ Add" and "Add both" (one tap, finish-matched to the gold/silver chosen on the page).
  // Plain buttons, not cart forms, so store-wide upsell apps that hijack /cart/add forms leave them alone.
  function chosenFinish() {
    var sw = document.querySelector('[data-product-section] fieldset .swatch');
    var fs = sw && sw.closest('fieldset');
    var on = fs && fs.querySelector('input:checked');
    return on ? on.value.toLowerCase() : '';
  }
  function matchFinish(btn, fallback) {
    var map = btn.getAttribute('data-finish-map') || '';
    var f = chosenFinish();
    if (!f || !map) return Number(fallback);
    var hit = map.split(',').filter(function (kv) { return kv && kv.split(':')[0] === f; })[0];
    return Number(hit ? hit.split(':')[1] : fallback);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-add], [data-add-both]');
    if (!btn || !window.fetch) return;
    e.preventDefault();
    var items = [];
    if (btn.hasAttribute('data-add-both')) {
      var mine = document.querySelector('[data-product-section] [data-variant-id]');
      if (mine && mine.value) items.push({ id: Number(mine.value), quantity: 1 });
      items.push({ id: matchFinish(btn, btn.getAttribute('data-add-both')), quantity: 1 });
    } else {
      items.push({ id: matchFinish(btn, btn.getAttribute('data-quick-add')), quantity: 1 });
    }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding';
    fetch(routes.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return drawer ? refreshDrawer().then(openDrawer) : (window.location.href = routes.cart); })
      .then(function () { btn.textContent = 'Added'; })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }, true);

  // "Read the story": open the Story accordion and bring it into view.
  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-open-story]');
    if (!more) return;
    var d = document.getElementById('ProductStory');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawer && !document.querySelector('[data-cart-page]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.getAttribute('data-qty-change'), qtyBtn.getAttribute('data-qty'));
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.getAttribute('data-qty-input'), input.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var focusables = $$('a[href], button:not([disabled]), input, textarea, select', $('.cart-drawer__panel', drawer))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function changeLine(line, qty) {
    qty = Math.max(0, parseInt(qty, 10) || 0);
    return fetch(routes.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function () {
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      return refreshDrawer();
    });
  }

  /* ---------------- Product form ---------------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = $('#ProductForm', section) || $('form[action*="/cart/add"]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var errorEl = $('[data-form-error]', section);

    function selectedOptions() {
      return $$('fieldset[data-option-index]', section).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function showMedia(id) {
      if (!id) return;
      var target = $('[data-media="' + id + '"]', section);
      if (!target) return;
      $$('[data-media]', section).forEach(function (el) { el.hidden = el !== target; });
      $$('[data-thumb]', section).forEach(function (t) {
        if (t.getAttribute('data-thumb') === String(id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    function markAvailability(opts) {
      // Strike through values that have no available variant given the other selections.
      $$('fieldset[data-option-index]', section).forEach(function (fs, idx) {
        $$('input[type="radio"]', fs).forEach(function (input) {
          var trial = opts.slice(); trial[idx] = input.value;
          var match = data.variants.filter(function (v) {
            return trial.every(function (val, k) { return val === null || v.options[k] === val; });
          });
          var available = match.some(function (v) { return v.available; });
          input.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      $$('fieldset[data-option-index]', section).forEach(function (fs, idx) {
        var label = $('[data-option-label]', fs);
        if (label) label.textContent = opts[idx] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      var priceEl = $('[data-price-current]', section);
      if (priceEl) priceEl.textContent = v.price;
      var compareEl = $('[data-price-compare]', section);
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      showMedia(v.media);
      if (window.history && window.history.replaceState) {
        var url = section.getAttribute('data-url') + '?variant=' + v.id;
        window.history.replaceState({}, '', url);
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('fieldset[data-option-index] input')) update();
    });
    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showMedia(t.getAttribute('data-thumb'));
    });
    markAvailability(selectedOptions());

    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        fetch(routes.cartAdd, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag.');
            if (window.theme && window.theme.cartDrawer && drawer) return refreshDrawer().then(openDrawer);
            window.location.href = routes.cart;
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .then(function () { if (addBtn) { var v = findVariant(selectedOptions()); addBtn.disabled = !(v && v.available); } });
      });
    }
  });

  /* ---------------- Collection sort ---------------- */
  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------------- Recommendations ---------------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();
